import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Gateways'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      gatewaysGetCollectionAsyncByqueryOptions: build.query<
        GatewaysGetCollectionAsyncByqueryOptionsApiResponse,
        GatewaysGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Gateways'],
      }),
      gatewaysPostBynewGateway: build.mutation<
        GatewaysPostBynewGatewayApiResponse,
        GatewaysPostBynewGatewayApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway`,
          method: 'POST',
          body: queryArg.createGatewayDto,
        }),
        invalidatesTags: ['Gateways'],
      }),
      gatewaysGetAsyncByid: build.query<
        GatewaysGetAsyncByidApiResponse,
        GatewaysGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Gateway/${queryArg.id}` }),
        providesTags: ['Gateways'],
      }),
      gatewaysDeleteAsyncByid: build.mutation<
        GatewaysDeleteAsyncByidApiResponse,
        GatewaysDeleteAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Gateways'],
      }),
      gatewaysPatchAsyncByidgateway: build.mutation<
        GatewaysPatchAsyncByidgatewayApiResponse,
        GatewaysPatchAsyncByidgatewayApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editGatewayDto,
        }),
        invalidatesTags: ['Gateways'],
      }),
      gatewaysGetConnectionInfoAsyncByidqueryOptions: build.query<
        GatewaysGetConnectionInfoAsyncByidqueryOptionsApiResponse,
        GatewaysGetConnectionInfoAsyncByidqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}/ConnectionInfo`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            Timestamp: queryArg.timestamp,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Gateways'],
      }),
      gatewaysPutApModeAsyncByidapMode: build.mutation<
        GatewaysPutApModeAsyncByidapModeApiResponse,
        GatewaysPutApModeAsyncByidapModeApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}/ApMode`,
          method: 'PUT',
          params: {
            apMode: queryArg.apMode,
          },
        }),
        invalidatesTags: ['Gateways'],
      }),
      gatewaysGetImageAsyncByid: build.query<
        GatewaysGetImageAsyncByidApiResponse,
        GatewaysGetImageAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Gateway/${queryArg.id}/Image` }),
        providesTags: ['Gateways'],
      }),
      gatewaysPutImageAsyncByidfile: build.mutation<
        GatewaysPutImageAsyncByidfileApiResponse,
        GatewaysPutImageAsyncByidfileApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}/Image`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['Gateways'],
      }),
      gatewaysDeleteImageAsyncByid: build.mutation<
        GatewaysDeleteImageAsyncByidApiResponse,
        GatewaysDeleteImageAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Gateway/${queryArg.id}/Image`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Gateways'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type GatewaysGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Gateway entities response */ ReadGatewayDto[];
export type GatewaysGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>GatewayId</strong> (default), <strong>LastActivity</strong>, <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>GatewayId</strong> (default), <strong>LastActivity</strong>, <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type GatewaysPostBynewGatewayApiResponse =
  /** status 201 Created */ object;
export type GatewaysPostBynewGatewayApiArg = {
  /** The entity to create */
  createGatewayDto: CreateGatewayDto;
};
export type GatewaysGetAsyncByidApiResponse =
  /** status 200 Gateway entity response */ ReadGatewayDto;
export type GatewaysGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type GatewaysDeleteAsyncByidApiResponse =
  /** status 204 No content */ object;
export type GatewaysDeleteAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type GatewaysPatchAsyncByidgatewayApiResponse =
  /** status 204 No content */ object;
export type GatewaysPatchAsyncByidgatewayApiArg = {
  /** The id of the Gateway */
  id: number;
  editGatewayDto: EditGatewayDto;
};
export type GatewaysGetConnectionInfoAsyncByidqueryOptionsApiResponse =
  /** status 200 ConnectionInfo entities response */ ReadSignalStrengthDto[];
export type GatewaysGetConnectionInfoAsyncByidqueryOptionsApiArg = {
  id: number;
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Timestamp using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(datetime)</code>
    Greater than or equal:
    <code>ge(datetime)</code>
    Greater than:
    <code>gt(datetime)</code>
    Less than or equal:
    <code>le(datetime)</code>
    Less than:
    <code>lt(datetime)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than or equal:
    <code>ge(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than:
    <code>gt(2021-01-01T16:00:00.0000000+02:00)</code>
    Less than or equal:
    <code>le(2021-01-02T16:00:00.0000000+02:00)</code>
    Less than:
    <code>lt(2021-01-02T16:00:00.0000000+02:00)</code></pre></div> */
  timestamp: string[];
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type GatewaysPutApModeAsyncByidapModeApiResponse =
  /** status 204 No content */ object;
export type GatewaysPutApModeAsyncByidapModeApiArg = {
  /** id of gateway */
  id: number;
  /** The AP mode to set */
  apMode: 'Normal' | 'WmBus';
};
export type GatewaysGetImageAsyncByidApiResponse = /** status 200 Ok */ Blob;
export type GatewaysGetImageAsyncByidApiArg = {
  /** Id of the gateway entity */
  id: number;
};
export type GatewaysPutImageAsyncByidfileApiResponse =
  /** status 201 Created */ object;
export type GatewaysPutImageAsyncByidfileApiArg = {
  /** Id of the gateway entity */
  id: number;
  body: {
    /** The image file to upload */
    file: Blob;
  };
};
export type GatewaysDeleteImageAsyncByidApiResponse =
  /** status 204 No content */ object;
export type GatewaysDeleteImageAsyncByidApiArg = {
  /** Id of the unit entity */
  id: number;
};
export type AccountNoRefsDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type GatewayActivitiesNoRefsDto = {
  SensorId: number;
  GatewayId: number;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
  LinkQualityIndication?: number;
};
export type GatewayExternalActivitiesNoRefsDto = {
  ExternalSensorId: number;
  GatewayId: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
};
export type GatewayConnectionStatus = {
  LatestDongleTimestamp?: string;
  LatestDongleSignalLevel?: number;
  LatestDongleImei?: string;
  LatestDongleWorkmode?: string;
  LatestDongleDeviceName?: string;
  LatestWifiTimestamp?: string;
  LatestWifiSignalLevel?: number;
  LatestWifiIpAddress?: string;
  LatestWifiMacAddress?: string;
  LatestWifiSsid?: string;
  LatestWifiChannel?: number;
  LatestWifiFrequency?: number;
  LatestMobileTimestamp?: string;
  LatestMobileImsi?: string;
  LatestMobileApn?: string;
  LatestMobileRssi?: number;
  LatestMobileRsrq?: number;
  LatestMobileRsrp?: number;
  LatestMobileCinr?: number;
  LatestEthernetTimestamp?: string;
  LatestEthernetIpAddress?: string;
  LatestEthernetMac?: string;
};
export type ReadGatewayDto = {
  GatewayId: number;
  Name?: string;
  Description?: string;
  ImageHash?: number;
  Account?: AccountNoRefsDto;
  LastActivity?: string;
  RegistrationDate?: string;
  SensorActivities?: GatewayActivitiesNoRefsDto[];
  ExternalSensorActivities?: GatewayExternalActivitiesNoRefsDto[];
  Latitude?: number;
  Longitude?: number;
  LocationAccuracy?: number;
  CurrentApplicationFirmware?: string;
  CurrentCommonFirmware?: string;
  ReportedApplicationFirmware?: string;
  Variant: 'Repeater' | 'Gateway';
  Online?: boolean;
  ConnectionStatus?: GatewayConnectionStatus;
  ApMode?: 'Normal' | 'WmBus';
  TargetApMode?: 'Normal' | 'WmBus';
  GatewayVersion?: string;
  HWRevision?: string;
  SWRevision?: string;
  OptoEye: boolean;
  Modem: boolean;
  PCT: boolean;
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type AccountIdDto = {
  AccountId: number;
};
export type CreateGatewayDto = {
  Name?: string;
  RfuId: number;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  LocationAccuracy?: number;
  Account: AccountIdDto;
};
export type ErrorResult4 = ErrorResult;
export type EditGatewayDto = {
  Name?: string;
  Latitude?: number;
  Longitude?: number;
  LocationAccuracy?: number;
  Description?: string;
};
export type ReadSignalStrengthDto = {
  GatewayId: number;
  Timestamp: string;
  DongleWorkmode?: string;
  DongleSignalLevel?: number;
  WifiFrequency?: number;
  WifiQuality?: string;
  WifiSignalLevel?: number;
  HasEthernet: boolean;
  MobileWorkmode?: string;
  MobileRssi?: number;
  MobileRsrq?: number;
  MobileRsrp?: number;
  MobileCinr?: number;
};
export const {
  useGatewaysGetCollectionAsyncByqueryOptionsQuery,
  useLazyGatewaysGetCollectionAsyncByqueryOptionsQuery,
  useGatewaysPostBynewGatewayMutation,
  useGatewaysGetAsyncByidQuery,
  useLazyGatewaysGetAsyncByidQuery,
  useGatewaysDeleteAsyncByidMutation,
  useGatewaysPatchAsyncByidgatewayMutation,
  useGatewaysGetConnectionInfoAsyncByidqueryOptionsQuery,
  useLazyGatewaysGetConnectionInfoAsyncByidqueryOptionsQuery,
  useGatewaysPutApModeAsyncByidapModeMutation,
  useGatewaysGetImageAsyncByidQuery,
  useLazyGatewaysGetImageAsyncByidQuery,
  useGatewaysPutImageAsyncByidfileMutation,
  useGatewaysDeleteImageAsyncByidMutation,
} = injectedRtkApi;
